import React from "react";
import { CircularProgress, Grid, Typography } from "@mui/material";

export default function CircularIndeterminate({ text }) {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      sx={{ mt: 2 }}
    >
      <Grid item>
        <CircularProgress></CircularProgress>
      </Grid>
      <Grid item>
        <Typography variant="body1" color="primary">
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
}
